// src/components/admin/flows/panels/TriggerConfigForm.js
import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { TRIGGER_EVENTS } from '../canvas/nodeRegistry';

const TriggerConfigForm = ({ config, onChange }) => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';

    const inputClass = `w-full px-3 py-2 rounded-lg text-sm border ${
        isDark ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300 text-gray-900'
    } focus:ring-2 focus:ring-blue-500 focus:outline-none`;

    const labelClass = `block text-xs font-medium mb-1 ${isDark ? 'text-gray-400' : 'text-gray-500'}`;

    const handleEventChange = (event) => {
        onChange({ ...config, event, filters: config.filters || {} });
    };

    return (
        <div className="space-y-4">
            {/* Event Selection */}
            <div>
                <label className={labelClass}>Trigger Event</label>
                <div className="space-y-1.5">
                    {TRIGGER_EVENTS.map((event) => {
                        const Icon = event.icon;
                        const isSelected = config.event === event.value;
                        return (
                            <button
                                key={event.value}
                                onClick={() => handleEventChange(event.value)}
                                className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-left text-sm transition-colors ${
                                    isSelected
                                        ? 'bg-blue-50 border border-blue-300 text-blue-700 dark:bg-blue-900/30 dark:border-blue-700 dark:text-blue-300'
                                        : `${isDark ? 'hover:bg-gray-700 text-gray-300 border border-transparent' : 'hover:bg-gray-100 text-gray-700 border border-transparent'}`
                                }`}
                            >
                                <Icon className={`w-4 h-4 flex-shrink-0 ${isSelected ? 'text-blue-500' : isDark ? 'text-gray-500' : 'text-gray-400'}`} />
                                <div className="min-w-0">
                                    <p className="font-medium text-xs">{event.label}</p>
                                    <p className={`text-[10px] ${isSelected ? 'text-blue-500 dark:text-blue-400' : isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                                        {event.description}
                                    </p>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>

            {/* Filters */}
            <div>
                <label className={labelClass}>Filters (optional)</label>
                <div className="space-y-2">
                    <input
                        type="text"
                        placeholder="Department filter..."
                        value={config.filters?.department_id || ''}
                        onChange={(e) => onChange({
                            ...config,
                            filters: { ...config.filters, department_id: e.target.value || undefined }
                        })}
                        className={inputClass}
                    />
                    <input
                        type="text"
                        placeholder="Designation filter..."
                        value={config.filters?.designation || ''}
                        onChange={(e) => onChange({
                            ...config,
                            filters: { ...config.filters, designation: e.target.value || undefined }
                        })}
                        className={inputClass}
                    />
                </div>
            </div>

            {/* Schedule config for scheduled triggers */}
            {config.event === 'scheduled' && (
                <div>
                    <label className={labelClass}>Cron Schedule</label>
                    <input
                        type="text"
                        placeholder="0 9 * * 1-5 (weekdays at 9am)"
                        value={config.schedule?.cron || ''}
                        onChange={(e) => onChange({
                            ...config,
                            schedule: { ...config.schedule, cron: e.target.value, timezone: config.schedule?.timezone || 'Asia/Kolkata' }
                        })}
                        className={inputClass}
                    />
                    <p className={`text-[10px] mt-1 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                        Uses cron syntax (day-level). "0 9 * * 1-5" = weekdays · day-of-month "L" = last day
                        of the month · "LW" = last working day (skips weekends &amp; company holidays).
                        Runs once on the matching day.
                    </p>
                </div>
            )}
        </div>
    );
};

export default TriggerConfigForm;
